import type {
  ApiBlobResource,
  ApiReturnBlobResource,
} from '@highimpact-frontend/api-types';
import { api_config } from '../../../api-commons';
import type { IResourceService } from './IResourceService';
import { defineQueryParams } from './TextResourceService';

class ImageResourceService
  implements IResourceService<ApiBlobResource, ApiReturnBlobResource>
{
  async add(params: ApiBlobResource): Promise<ApiReturnBlobResource> {
    const queryParams = defineQueryParams(params);
    const form = new FormData();
    form.append('text', params.file ? params.file.name : '');
    form.append('file', params.file ? params.file : '');
    const response = await api_config.post(`/resources/?${queryParams}`, form);
    return response.data;
  }

  async update(
    id: number,
    params: ApiBlobResource
  ): Promise<ApiReturnBlobResource> {
    const queryParams = defineQueryParams(params);
    const form = new FormData();
    form.append('text', 'text');
    if (params.file) {
      form.append('file', params.file);
    }
    const response = await api_config.put(
      `/resources/${id}?${queryParams}`,
      form
    );
    return response.data;
  }

  async delete(id: number): Promise<ApiReturnBlobResource> {
    const response = await api_config.delete(`/resources/${id}`);
    return response.data;
  }

  async get(ids: number[]): Promise<ApiReturnBlobResource[]> {
    const qyeryParams = ids.map((id) => `ids=${id}`).join('&');
    const response = await api_config.get(`/resources/ids/?${qyeryParams}`);
    return response.data;
  }

  async getByEntity(params: {
    project_id: number | null;
    site_id: number | null;
    device_id: number | null;
  }) {
    const context = params.site_id
      ? 'site'
      : params.project_id
      ? 'project'
      : params.device_id
      ? 'device'
      : 'default';
    const contextMap: { [key: string]: number | null } = {
      project: params.project_id,
      site: params.site_id,
      device: params.device_id,
    };
    const query = `resources/${context}s/${contextMap[context]}`;
    const response = await api_config.get(query);
    return response.data;
  }
}

const blobService = new ImageResourceService();
export default blobService;
